//import {Link} from 'react-router-dom';
import React/*, {useState}*/ from 'react';

import {useracc} from '../utils/functions';
import {UserContext} from '../utils/usercontext';
import EventEmitter from '../utils/emmiter';
//import Genres from './components/genres/genres';
//import AudioBox from './components/audio/audiobox';
//import moment from 'moment';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import './components/fontawesome/fontawesome';


//import { Swiper, SwiperSlide } from 'swiper/react';
//import { Autoplay, Pagination, Navigation } from "swiper";
//import 'swiper/css';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Button from 'react-bootstrap/Button';

import {Typography1, TypographyShadow} from './elements.js';

export default class SupportCanvas extends React.Component {
  static contextType = UserContext;
  #refCanvas;
  constructor(props) {
    super(props);
    this.state = {
			status: true,
      _timeline: [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29],
      fps: {
        // FPS limiter
        rate: 1000 / 30,
        last: 0,
        // Video duration
        duration: 30000, // ms
        current: 0, // current progress in ms
        isPlaying: false // is playing
      },
      min: [1280, 720],
      max: [0, 0],
      view: 'Typography',
      items: [],
		};
    this.refCanvas = React.createRef();
    this.paint = this.paint.bind(this);

    this.play = this.play.bind(this);
    this.pause = this.pause.bind(this);
    this.duration = this.duration.bind(this);

    this.setView = this.setView.bind(this);
  };

  async componentDidMount() {
		//document.title = "Mix365 Radio - your music station streaming 24/7";
		const value = this.context;
		const getUser = await useracc();
		value.setUser( getUser );
		value.setTheme( '/themes/default-dark.css' );
		EventEmitter.emit('/client', {data: 'no value'});

    const canvas = this.refCanvas.current;
    canvas.width = 1280;
    canvas.height = 720;
    this.animation = requestAnimationFrame(this.paint);
    this.loadElement();
	}

	componentWillUnmount() {
	}


  play() {
    let fps = this.state.fps;
    fps.isPlaying = true;
  }
  
  pause() {
    let fps = this.state.fps;
    fps.isPlaying = false;
  }

  duration(time) {
    let fps = this.state.fps;
    fps.current = time * 1000;
  }


  setView(view) {
    this.setState({view});
  }


  async loadElement(element) {
    let items = this.state.items;
    
    /*
    let _element = new Typography1({
      text: 'WELCOME',
      fontFamily: 'Lucida Console',
      fontSize: 30,
      paths: [],
      timeline: [0, 20, 80, 100] // needs to be percents
    });
    await _element.load(this.refCanvas.current, this.state.fps);
    items.push(_element);
    */

    let _element2 = new TypographyShadow({
      text: 'We are requiring several words to accomplish this', 
      fontFamily: 'Lucida Console',
      toUpperCase: true,
      fontSize: 24,
      paths: [],
      timeline: [0, 20, 80, 100] // needs to be percents
    });
    await _element2.load(this.refCanvas.current, this.state.fps);
    items.push(_element2);
    this.setState({items});
  }


  async paint(now) {
    this.timeframe = now;
    const canvas = this.refCanvas.current;
    const ctx = canvas.getContext('2d');
    if( !ctx ) return;
    
    ctx.strokeStyle = "blue";

    let fps = this.state.fps;
    //if( Date.now() - fps.last > fps.rate ) {

      if( fps.isPlaying ) fps.current += fps.rate;
      if( fps.current > fps.duration ) fps.current = fps.current - fps.duration;

      let items = this.state.items;
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      
      for( let i in items ) {

        //---- Update
        //if( items[i].update ) items[i].update(fps);

        //---- Paint
        if( items[i].paint ) {
          let {min, max} = items[i].paint(ctx, fps);
          let _min = this.state.min;
          let _max = this.state.max;
          //console.log(min, max);
          if( min[0] < _min[0] || min[1] < _min[1] ) {
            _min[0] = Math.round(min[0]); _min[1] = Math.round(min[1]);
            this.setState({min: _min});
          }
          if( max[0] > _max[0] || max[1] < _max[1] ) {
            _max[0] = Math.round(max[0]); _max[1] = Math.round(max[1]);
            this.setState({max: _max});
          }
        }
      }

      //console.log(this.state.min, this.state.max);
      //ctx.strokeStyle = "green";
      //ctx.rect(this.state.min[0], this.state.min[1], this.state.max[0]-this.state.min[0], this.state.max[1]-this.state.min[1]);
      //ctx.stroke();


      fps.last = Date.now();
      this.setState({fps});
    //}




    this.animation = requestAnimationFrame(this.paint);
  }

	render() {
		
		return (
			<>
				<div className="d-sm-flex d-block align-items-center justify-content-between page-header-breadcrumb">
					<h4 className="fw-medium mb-0">Canvas</h4>
					<div className="ms-sm-1 ms-0">
						<nav>
							<ol className="breadcrumb mb-0">
								{/*<li className="breadcrumb-item"><a href="javascript:void(0);">Ui Elements</a></li>*/}
								<li className="breadcrumb-item active" aria-current="page">Canvas</li>
							</ol>
						</nav>
					</div>
				</div>

				{this.state.status &&
					<div className="main-content app-content">
						<div className="container-fluid">
							<div className="my-4">
								<Row>
									<Col xs={12} className="mt-3">
                    <div style={{backgroundColor: '#ffffff'}}>
										  <canvas ref={this.refCanvas} {...this.props} style={{position: 'relative', left: 0, top: 0, width: 1280, height: 720}} />
                    </div>
									</Col>
                  <Col xs={12} className="mt-3">
                    <div style={{backgroundColor: '#ffffff'}} className="d-flex">
                      
                        <ButtonGroup size="sm">
                          {this.state.fps.isPlaying === false ?
                            <Button size="sm" onClick={this.play}><FontAwesomeIcon icon="play" /></Button>
                          :
                            <Button size="sm" onClick={this.pause}><FontAwesomeIcon icon="pause" /></Button>
                          }
                        </ButtonGroup>
                        <div style={{width: '100%'}}>
                          <div className="d-flex">
                            {this.state._timeline.map((e, i)=>{
                              return (
                                <div key={i} style={{width: `${100/30}%`, height: 20, backgroundColor: '#555555', borderLeft: '1px solid #aaaaaa'}} onClick={()=>this.duration(i)}></div>
                              )
                            })}
                          </div>
                          <div className="progress" role="progressbar" aria-valuenow="80" aria-valuemin="0" aria-valuemax="100">
                            <div className="progress-bar bg-warning progress-bar-striped progress-bar-animated" style={{width: `${(this.state.fps.current/1000)/30*100}%`}}></div>
                          </div>
                        </div>
                      
                    </div>
                  </Col>
                  <Col xs={12} className="mt-3">
                    <div style={{backgroundColor: '#ffffff'}}>
                      <ButtonGroup size="sm">
                        <Button onClick={()=>this.setView('Typography')}>Typography</Button>
                        <Button onClick={()=>this.setView('Backgrounds')}>Backgrounds</Button>
                        <Button onClick={()=>this.setView('Elements')}>Elements</Button>
                      </ButtonGroup>
                      
                    </div>
                  </Col>

                  {this.state.view === 'Typography' &&
                    <Col xs={12} className="mt-3">
                    </Col>
                  }
								</Row>
							</div>
						</div>
					</div>
				}
			</>
		);
	}
}
